import { Component, effect, input, signal } from '@angular/core';
import { FormLocalizationService } from "../form-localization.service";

@Component({
    selector: '[localized-input-label]',
    templateUrl: './localized-input-label.component.html',
    styleUrl: './localized-input-label.component.scss',
    host: {
        'class': "w-full flex align-items-center"
    },
    standalone: true
})
export class LocalizedInputLabelComponent
{
    localizationLanguageLabel = signal('');

    constructor(private localizationService: FormLocalizationService)
    {
        effect(() => {
            let lang = this.localizationService.localizationLanguage();
            this.localizationLanguageLabel.set(lang.name);
        });
    }

    ngOnInit()
    {
    }

}
